import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BasicForm } from 'src/app/shared/basic-form';
import { setToLocalStorage } from 'src/app/shared/helpers';

@Component({
  selector: 'app-insurance-days',
  templateUrl: './insurance-days.component.html',
  styleUrls: ['./insurance-days.component.scss']
})
export class InsuranceDaysComponent extends BasicForm implements OnInit {

  ngOnInit(): void {
    this.formAlias = 'InsuranceDays';
    this.form = this.fb.group({
      days: ['', [Validators.required]]
    });
    this.form.patchValue(this.formData);
  }

  onSubmit() {
    if (this.form.valid) {
      setToLocalStorage('policy', this.formAlias, this.form.value);
      this.stepService.nextStep();
    }
    else {
      this.submitted = true;
    }

  }

}
